export default class LoadingSpinner {
    onCreate(input) {
        if (input) {
            this.spinnerId = input.spinnerId;
            this.state = {
                isShow: !!(input.isShow && input.isShow === 'true')
            };
        }
    }
    onMount() {
        if (this.spinnerId) {
            document.addEventListener('str-loading-spinner-toggle-event', evt => {
                if (evt.detail && evt.detail.id === this.spinnerId) {
                    this.state.isShow = evt.detail.isShow;
                }
            });
        }
    }
    static hide(spinnerId) {
        if (spinnerId) {
            document.dispatchEvent(
                new CustomEvent('str-loading-spinner-toggle-event', {
                    detail: {
                        id: spinnerId,
                        isShow: false
                    }
                })
            );
        }
    }
    static show(spinnerId) {
        if (spinnerId) {
            document.dispatchEvent(
                new CustomEvent('str-loading-spinner-toggle-event', {
                    detail: {
                        id: spinnerId,
                        isShow: true
                    }
                })
            );
        }
    }
}
